var styles = {"loading":"ButtonLoading-module_loading__sLz5-"};

export { styles as default };
